import styled from "styled-components";
import { Button } from "components/Button";

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  height: 100%;
  max-height: 600px;
  overflow: hidden;
  border-radius: 8px;
  background: rgb(0, 0, 0);
`;

export const TableWrapper = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  width: 100%;
  margin-bottom: 10px;
  padding: 0;
`;

export const CloseBtn = styled.img`
  cursor: pointer;
  width: 32px;
  height: 13px;
`;

export const CustomButton = styled(Button)`
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const TextBtnYes = styled.p`
  color: #ffffff;
`;
